<script>
    import ShareRedirect from 'views/components/shareRedirect/ShareRedirect.svelte'

    const { params } = $props()
</script>

<ShareRedirect
    {params}
    collection={Backbone.Collection.sections}
    sourceField="source_section_id"
    showPathPrefix="/sections/show/"
    notFoundMessage={window.i18n.gettext('This section could not be found.')}
    selectTitle={window.i18n.gettext('Select a section')}
></ShareRedirect>
